import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/react';
import { XMarkIcon, ChevronDownIcon } from '@heroicons/react/24/outline';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
  'August', 'September', 'October', 'November', 'December'];

// StatusHero headline recipe (VISUAL_IDENTITY §4.6), used by the privileged
// forecaster picker. A forecaster viewing themselves gets no name heading.
const HEADLINE = 'text-2xl sm:text-3xl font-medium tracking-tight leading-tight text-slate-900 dark:text-white';

const HeadlinePicker = ({ options, userId, onSelectUser }) => {
  const current = options.find((o) => o.value === userId);
  return (
    <Menu as="div" className="relative">
      <MenuButton
        className={`group inline-flex items-center gap-2 ${HEADLINE} focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 ring-offset-2 rounded-sm`}
      >
        <span className="truncate max-w-md">{current ? current.label : 'Select a forecaster'}</span>
        <ChevronDownIcon className="h-5 w-5 flex-shrink-0 text-gray-400 transition-colors group-hover:text-brand-600 dark:group-hover:text-brand-400" />
      </MenuButton>
      <MenuItems
        className="absolute left-0 z-30 mt-2 w-72 max-h-72 overflow-auto rounded-md bg-white dark:bg-gray-700 py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
      >
        {options.map((opt) => (
          <MenuItem key={opt.value}>
            {({ focus }) => (
              <button
                type="button"
                onClick={() => onSelectUser(opt.value)}
                className={`block w-full truncate px-3 py-1.5 text-left text-sm ${
                  focus ? 'bg-brand-600 text-white' : 'text-gray-800 dark:text-gray-100'
                } ${opt.value === userId ? 'font-semibold' : ''}`}
              >
                {opt.label}
              </button>
            )}
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
};

const PaneHeader = ({
  canPick, options, userId, year, month, marketCount, roleLabel, onSelectUser, onClose,
}) => (
  <header className="px-5 sm:px-14 pt-6">
    <div className="flex items-start justify-between gap-4">
      <div className="min-w-0">
        <p className="text-[11px] font-mono uppercase tracking-[0.14em] text-gray-400 dark:text-gray-500">
          Cross-market performance · {MONTHS[(month || 1) - 1]} {year}
          {marketCount > 0 && <> · {marketCount} market{marketCount === 1 ? '' : 's'}</>}
          {roleLabel && <> · {roleLabel}</>}
        </p>
        {/* Privileged viewers get the forecaster picker as the headline; a
            forecaster viewing themselves gets no name heading at all (they know
            who they are) - the eyebrow carries the context. */}
        {canPick && (
          <div className="mt-2">
            <HeadlinePicker options={options} userId={userId} onSelectUser={onSelectUser} />
          </div>
        )}
      </div>
      <button
        type="button"
        onClick={onClose}
        className="mt-1 rounded-md p-1 text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 ring-offset-2"
        aria-label="Close performance pane"
      >
        <XMarkIcon className="h-5 w-5" />
      </button>
    </div>
  </header>
);

export default PaneHeader;
